import { createFileRoute } from "@tanstack/react-router";
import { RuleSetList } from "@/components/data-quality/rule-set-screens";
import { dqRuleSets } from "@/api/data-quality";

export const Route = createFileRoute("/_app/data-quality/rules/")({
  component: RulesList,
});

function RulesList() {
  return (
    <RuleSetList
      kind="dq"
      query={dqRuleSets.useList()}
      save={dqRuleSets.useSave()}
      detailPath="/data-quality/rules/$id"
      title="Quality rule sets"
      emptyBody="Create a reusable set of validation rules to reference from pipeline VALIDATE steps."
    />
  );
}
